import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rejectlenderoffer',
  templateUrl: './rejectlenderoffer.component.html',
  styleUrls: ['./rejectlenderoffer.component.css']
})
export class RejectlenderofferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
